import { BASE_URL } from '@lib/constants';

export default async function checkUserIsAdvisor(token) {
	const response = await fetch(`${BASE_URL}/wp-json/edu_api/user/is_editor`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
	});

	const responseData = await response.json();

	return responseData === true;
}
